import { render, staticRenderFns } from "./index.vue?vue&type=template&id=36b176e9&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b176e9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36b176e9')) {
      api.createRecord('36b176e9', component.options)
    } else {
      api.reload('36b176e9', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=36b176e9&scoped=true", function () {
      api.rerender('36b176e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/credit/config/index.vue"
export default component.exports